import keyMirror from 'keymirror';

export const imageSizeType = keyMirror({
  small: null,
  medium: null,
  large: null,
});

export default [
  {
    value: imageSizeType.small,
    label: 'Small',
  },
  {
    value: imageSizeType.medium,
    label: 'Medium',
  },
  {
    value: imageSizeType.large,
    label: 'Large',
  },
];
